import { render, staticRenderFns } from "./DataEdit.vue?vue&type=template&id=b826ae8c"
import script from "./DataEdit.vue?vue&type=script&lang=js"
export * from "./DataEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports